import React from 'react';
import Editor from "@monaco-editor/react";

import * as Antd from 'antd';
import * as SYS from '.';

export const ActionForm = props => {
    const [form] = Antd.Form.useForm();

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
    };

    const tailLayout = {
        wrapperCol: { span: 18, offset: 6 },
    };

    return (
        <Antd.Form
            {...layout}
            form={form}
            initialValues={props.initialValues}
            onFinish={values => {
                values.script = btoa(values.decodedScript);
                delete values.decodedScript;
                if (props.onSuccess) {
                    props.onSuccess(values);
                }
            }}
            onFinishFailed={(err) => {
                console.log(err);
            }}
        >
            <Antd.Row>
                <Antd.Col span={8}>
                    {props.initialValues && props.initialValues.id
                        ? <Antd.Form.Item name="id" label="ID">
                            <Antd.Input disabled={true} />
                        </Antd.Form.Item>
                        : null}
                    <Antd.Form.Item
                        name="code"
                        label="Code"
                        rules={[{ required: true }]}
                    >
                        <Antd.Input />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true }]}
                    >
                        <Antd.Input />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="connector"
                        label="Connector"                        
                    >
                        <SYS.ConnectorSelect
                            allowClear={true}
                            identificator="code"
                        />
                    </Antd.Form.Item>
                </Antd.Col>
                <Antd.Col span={16}>
                    <Antd.Form.Item
                        noStyle
                        name="decodedScript"
                        label="Script"
                        rules={[{ required: true }]}
                    >
                        <Editor
                            height="80vh"
                            options={{
                                fontSize: 12
                            }}
                            defaultLanguage="javascript"                            
                            {...props}
                        />
                    </Antd.Form.Item>
                </Antd.Col>
            </Antd.Row>

            <Antd.Form.Item
                {...tailLayout}
                style={{
                    marginTop: 10
                }}
            >
                <Antd.Button
                    type="primary"
                    htmlType="submit"
                >
                    Submit
                </Antd.Button>
            </Antd.Form.Item>
        </Antd.Form >
    );
}